<template>

  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="90%" append-to-body @closed="onClosed">

    <template slot="title">

      <div class="doc-dialog-header">

        <span class="doc-dialog-title">{{ dialogTitle }}</span>

        <div v-if="showViewToolbar" class="doc-dialog-actions">

          <el-button-group>

            <workflow-doc-buttons biz-type="ratioIn" :biz-id="form.ratioInId" perm="inventory:ratioIn" :approve-status="String(form.approveStatus || '0')" @approve="approve(true)" @unapprove="approve(false)" />

            <el-button v-if="isAuth('inventory:ratioIn:update')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="readonly = false">修改</el-button>

            <el-button v-if="isAuth('inventory:ratioIn:delete')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="remove">删除</el-button>

          </el-button-group>

        </div>

      </div>

    </template>

    <el-form :model="form" label-width="90px">

      <el-row>

        <el-col :span="6"><el-form-item label="单号" required><el-input v-model="form.ratioInCode" :disabled="formDisabled || codeReadonly || !!form.ratioInId" :placeholder="codeReadonly ? '保存时自动编号' : ''" /></el-form-item></el-col>

        <el-col :span="6"><el-form-item label="日期" required><el-date-picker v-model="form.ratioInDate" type="date" value-format="yyyy-MM-dd" style="width:100%" :disabled="formDisabled" /></el-form-item></el-col>

        <el-col :span="6">

          <el-form-item label="成品编码" required>

            <el-input v-model="form.productMaterialCode" :disabled="formDisabled" placeholder="输入成品编码" @blur="fillProduct">

              <el-button v-if="!formDisabled" slot="append" @click="productPick = true">选择</el-button>

            </el-input>

          </el-form-item>

        </el-col>

        <el-col :span="6"><el-form-item label="成品名称"><el-input v-model="form.productMaterialName" disabled /></el-form-item></el-col>

        <el-col :span="6"><el-form-item label="配比数量" required><el-input-number v-model="form.productQuantity" :min="0" :precision="2" style="width:100%" :disabled="formDisabled" @change="recalcBom" /></el-form-item></el-col>

        <el-col :span="6"><el-form-item label="备注"><el-input v-model="form.remark" :disabled="formDisabled" /></el-form-item></el-col>

      </el-row>

      <el-row v-if="form.ratioInId">

        <el-col :span="6">

          <el-form-item label="审核状态">

            <el-tag :type="statusTagType" size="small">{{ statusText }}</el-tag>

          </el-form-item>

        </el-col>

      </el-row>

    </el-form>

    <div v-if="inventoryBarcodeEnabled && !formDisabled" class="line-tools">

      <el-input v-model="barcodeScanCode" size="small" placeholder="扫描条码解析物料（非序列号）" clearable style="width:320px;" @keyup.enter.native="onBarcodeScanForLine" />

      <el-button type="primary" size="small" style="margin-left:8px;" @click="onBarcodeScanForLine">扫码加行</el-button>

    </div>

    <div class="line-tools">

      <el-button v-if="!formDisabled" type="primary" size="small" @click="addLine">新增行</el-button>

      <el-button v-if="!formDisabled" type="primary" size="small" style="margin-left:8px;" @click="materialVisible = true">选择物料</el-button>

      <el-button v-if="!formDisabled" type="primary" size="small" style="margin-left:8px;" @click="fillBom">按BOM填充子件</el-button>

      <el-upload v-if="!formDisabled" :show-file-list="false" action="" :http-request="doImport" accept=".xlsx" style="display:inline-block;margin-left:8px;">

        <el-button type="primary" size="small">导入(产品编码)</el-button>

      </el-upload>

      <el-button v-if="!formDisabled" size="small" style="margin-left:8px;" @click="downloadTemplate">下载导入模板</el-button>

      <el-button v-if="!formDisabled" size="small" style="margin-left:8px;" @click="fillDefaultWarehouses">按默认仓库补库位</el-button>

      <el-button v-if="!formDisabled" size="small" style="margin-left:8px;" @click="clearWarehouses">清空库位</el-button>

      <el-button v-if="!formDisabled" size="small" style="margin-left:8px;" @click="clearLines">清空子件</el-button>

    </div>

    <el-table border :data="form.lines" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">

      <el-table-column type="index" label="序号" width="60" align="center" />

      <el-table-column label="子件编码" min-width="140">

        <template slot-scope="scope"><el-input v-model="scope.row.materialCode" :disabled="formDisabled" placeholder="输入产品编码" @blur="fillLine(scope.row)" /></template>

      </el-table-column>

      <el-table-column prop="materialName" label="子件名称" min-width="140" />

      <el-table-column v-if="inventoryBarcodeEnabled" label="序列号" header-align="center" min-width="280">

        <template slot-scope="scope">

          <inventory-line-serial-panel v-if="isSerialMaterial(scope.row)" :value="scope.row.serialNos" :expected-qty="serialExpectedQty(scope.row)" :readonly="formDisabled" @input="v => $set(scope.row, 'serialNos', v)" />

          <span v-else style="color:#909399;">—</span>

        </template>

      </el-table-column>

      <el-table-column label="入库数量" width="160">

        <template slot-scope="scope"><el-input-number v-model="scope.row.quantity" :disabled="formDisabled" :min="0" :precision="2" style="width:100%" @change="unlockLine(scope.row)" /></template>

      </el-table-column>

      <el-table-column label="入库库位" min-width="250">

        <template slot-scope="scope"><warehouse-location-select v-model="scope.row.wareHouseId" :disabled="formDisabled" /></template>

      </el-table-column>

      <el-table-column v-if="!formDisabled" label="操作" width="70" align="center">

        <template slot-scope="scope"><el-button type="text" size="small" @click="form.lines.splice(scope.$index, 1)">删除</el-button></template>

      </el-table-column>

    </el-table>

    <span slot="footer">

      <el-button @click="visible = false">取消</el-button>

      <el-button v-if="!formDisabled" type="primary" :loading="saving" @click="save">确定</el-button>

    </span>



    <material-selector :visible.sync="materialVisible" multiple @select-multiple="chooseMaterials" />

    <material-selector :visible.sync="productPick" :multiple="false" @select="chooseProduct" />

  </el-dialog>

</template>



<script>

import WorkflowDocButtons from '../../components/WorkflowDocButtons.vue'

import request from '../../api/request'

import { fetchPerms } from '../../api/auth'

import WarehouseLocationSelect from '../../components/WarehouseLocationSelect.vue'

import MaterialSelector from '../../components/MaterialSelector.vue'

import InventoryLineSerialPanel from '../../components/InventoryLineSerialPanel.vue'

import { today, fillMaterialRow, downloadInventoryTemplate, importInventoryLines, showImportError, postDoc, mergeQtyLines, materialCodeKey, fillMaterialDefaultWarehouses } from './inventoryShared'

import inventoryBarcodeMixin from '../../mixins/inventory-barcode'

import { workflowStatusText, workflowStatusTagType } from '../../utils/workflow'



export default {

  name: 'RatioInAddOrUpdate',

  components: { WorkflowDocButtons, WarehouseLocationSelect, MaterialSelector, InventoryLineSerialPanel },

  mixins: [inventoryBarcodeMixin],

  data() {

    return {

      kind: 'ratioIn',

      visible: false,

      readonly: false,

      saving: false,

      actionBusy: false,

      codeReadonly: false,

      materialVisible: false,

      productPick: false,

      permCodes: [],

      form: this.blank()

    }

  },

  computed: {

    formDisabled() {

      const wf = this.form.workflowStatus

      return this.readonly || String(this.form.approveStatus) === '2' || !!(wf && wf !== 'draft' && wf !== 'rejected')

    },

    canEditDoc() {

      const wf = this.form.workflowStatus

      return String(this.form.approveStatus) !== '2' && (!wf || wf === 'draft' || wf === 'rejected')

    },

    showViewToolbar() { return this.readonly && !!this.form.ratioInId },

    dialogTitle() {

      if (this.readonly || String(this.form.approveStatus) === '2') return '查看配比入库单'

      return this.form.ratioInId ? '修改配比入库单' : '新增配比入库单'

    },

    statusText() { return workflowStatusText(this.form.workflowStatus, this.form.approveStatus) },

    statusTagType() { return workflowStatusTagType(this.form.workflowStatus, this.form.approveStatus) }

  },

  created() {

    this.loadPerms()

    this.loadInventoryBarcodePolicy()

  },

  methods: {

    isAuth(perm) {

      const user = this.$store.state.user || {}

      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []

      const role = String(user.roleCode || '')

      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true

      return this.permCodes.indexOf(perm) >= 0

    },

    loadPerms() {

      fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})

    },

    blank() {

      return { ratioInId: '', ratioInCode: '', ratioInDate: today(), productMaterialId: '', productMaterialCode: '', productMaterialName: '', productQuantity: 1, productWareHouseId: '', remark: '', approveStatus: '0', workflowStatus: '', lines: [] }

    },

    init(id, readonly) {

      this.visible = true

      this.readonly = !!readonly

      this.codeReadonly = false

      this.actionBusy = false

      this.form = this.blank()

      if (!id) { this.resolveCode(); return }

      request.get('/inventory/ratioIn/info/' + id).then(res => {

        const data = res.data || {}

        this.form = Object.assign(this.blank(), data, { lines: data.lines || [], productQuantity: data.productQuantity == null ? 1 : Number(data.productQuantity), approveStatus: data.approveStatus != null ? String(data.approveStatus) : '0' })

        this.rememberBomUnits()

      }).catch(() => {})

    },

    onClosed() {

      this.form = this.blank()

      this.readonly = false

    },

    resolveCode() {

      request.post('/base/docNumberRule/resolve', { docType: 'ratioIn' }).then(res => {

        const data = res.data || {}

        this.codeReadonly = !!data.codeReadonly

        if (this.codeReadonly && data.previewCode) this.form.ratioInCode = data.previewCode

      }).catch(() => {})

    },

    fillProduct() {

      const code = (this.form.productMaterialCode || '').trim()

      if (!code) return

      fillMaterialRow({ materialCode: code }).then(m => {

        if (!m) { this.$message.warning('未找到该成品编码'); return }

        this.form.productMaterialId = m.materialId

        this.form.productMaterialCode = m.materialCode

        this.form.productMaterialName = m.materialName

      }).catch(() => {})

    },

    chooseProduct(m) {

      if (!m || !m.materialId) return

      this.form.productMaterialId = m.materialId

      this.form.productMaterialCode = m.materialCode

      this.form.productMaterialName = m.materialName

      if (!this.form.ratioInId && (!this.form.lines || !this.form.lines.length)) this.fillBom()

    },

    addLine() { this.form.lines.push({ materialCode: '', materialName: '', quantity: 0, wareHouseId: '', remark: '', _bomUnitQty: null }) },

    fillLine(row) { fillMaterialRow(row).then(m => { if (m === null) this.$message.warning('未找到该产品编码') }).catch(() => {}) },

    chooseMaterials(materials) {

      (materials || []).forEach(m => {

        this.form.lines.push({ materialCode: m.materialCode, materialName: m.materialName, quantity: 1, wareHouseId: '', remark: '', _bomUnitQty: null })

      })

    },

    fillBom() {

      if (!this.form.productMaterialId) { this.$message.warning('请先选择成品'); return }

      request.get('/base/materialBom/list', { params: { materialId: this.form.productMaterialId } }).then(res => {

        const rows = (res.data || []).filter(r => String(r.approveStatus) === '2' && String(r.enabled) === '1' && (!r.parentId || r.parentId === '0' || r.parentId === ''))

        if (!rows.length) { this.$message.warning('该成品当前无已审批且生效的一级BOM子件'); return }

        const qty = Number(this.form.productQuantity || 0)

        this.form.lines = rows.map(r => {

          const unit = Number(r.quantity || 0) * (1 + Number(r.loss || 0) / 100)

          return {

            materialCode: r.childMaterialCode,

            materialName: r.childMaterialName,

            quantity: Number((unit * qty).toFixed(2)),

            wareHouseId: '',

            remark: '',

            _bomUnitQty: unit

          }

        })

        const tasks = fillMaterialDefaultWarehouses(this.form, {})

        const done = () => this.$message.success('已按 BOM 自动带出子件')

        if (!tasks.length) { done(); return }

        Promise.all(tasks).then(done)

      }).catch(() => {})

    },

    rememberBomUnits() {

      const head = Number(this.form.productQuantity || 0)

      ;(this.form.lines || []).forEach(line => {

        line._bomUnitQty = head > 0 ? Number(line.quantity || 0) / head : null

      })

    },

    recalcBom() {

      const qty = Number(this.form.productQuantity || 0)

      if (!(qty > 0)) return

      ;(this.form.lines || []).forEach(line => {

        if (line._bomUnitQty != null) line.quantity = Number((Number(line._bomUnitQty) * qty).toFixed(2))

      })

    },

    unlockLine(line) {

      const qty = Number(this.form.productQuantity || 0)

      if (!line || line._bomUnitQty == null || !(qty > 0)) return

      const expected = Number((Number(line._bomUnitQty) * qty).toFixed(2))

      if (Number(line.quantity) !== expected) line._bomUnitQty = null

    },

    downloadTemplate() { downloadInventoryTemplate('ratioIn', '配比入库导入模板.xlsx').catch(() => this.$message.error('模板下载失败')) },

    doImport(req) {

      importInventoryLines('ratioIn', req.file).then(lines => {

        lines.forEach(item => {

          this.form.lines.push({ materialId: item.materialId, materialCode: item.materialCode, materialName: item.materialName || '', quantity: item.quantity, wareHouseId: item.wareHouseId || '', batchNo: item.batchNo || '', supplierId: item.supplierId || '', supplierName: item.supplierName || '', remark: item.remark || '', _bomUnitQty: null })

        })

        this.$message.success('导入成功')

      }).catch(e => showImportError(this, e))

    },

    clearLines() {

      if (!this.form.lines || !this.form.lines.length) { this.$message.info('当前无子件明细'); return }

      this.$confirm('确定清空全部子件明细？', '提示', { type: 'warning' }).then(() => {

        this.form.lines = []

        this.$message.success('已清空子件明细')

      }).catch(() => {})

    },

    fillDefaultWarehouses() {

      const tasks = fillMaterialDefaultWarehouses(this.form, {})

      if (!tasks.length) { this.$message.info('没有可填充的空库位'); return }

      Promise.all(tasks).then(() => this.$message.success('已按物料默认仓库补齐空库位'))

    },

    clearWarehouses() {

      ;(this.form.lines || []).forEach(line => { line.wareHouseId = '' })

      this.$message.success('已清空子件库位')

    },

    save() {

      if (!this.codeReadonly && !(this.form.ratioInCode || '').trim()) { this.$message.error('单号不能为空'); return }

      if (!this.form.ratioInDate) { this.$message.error('日期不能为空'); return }

      if (!(this.form.productMaterialCode || '').trim()) { this.$message.error('成品编码不能为空'); return }

      if (!(Number(this.form.productQuantity) > 0)) { this.$message.error('配比数量必须大于0'); return }

      const merged = mergeQtyLines(this.form.lines, materialCodeKey)

      this.form.lines = merged.lines

      if (merged.hadDuplicate) this.$message.warning('检测到重复物料，已自动合并后再保存')

      if (!this.form.lines.length) { this.$message.error('请至少维护一条子件明细'); return }

      const id = this.form.ratioInId

      const body = {

        id, code: this.form.ratioInCode, bizDate: this.form.ratioInDate,

        ratioInId: id, ratioInCode: this.form.ratioInCode, ratioInDate: this.form.ratioInDate,

        productMaterialCode: this.form.productMaterialCode, productQuantity: this.form.productQuantity,

        productWareHouseId: this.form.productWareHouseId, remark: this.form.remark, lines: this.form.lines

      }

      this.saving = true

      postDoc('ratioIn', body, id).then(() => {

        this.$message.success('操作成功')

        this.visible = false

        this.$emit('refreshDataList')

      }).catch(() => {}).finally(() => { this.saving = false })

    },

    approve(pass) {

      this.$confirm(pass ? '审核后将更新库存现存量，是否继续?' : '弃审将冲回对应库存，是否继续?', '提示', { type: 'warning' }).then(() => {

        this.actionBusy = true

        request.post('/inventory/ratioIn/' + (pass ? 'approve' : 'unapprove'), { id: this.form.ratioInId }).then(() => {

          this.$message.success('操作成功')

          this.visible = false

          this.$emit('refreshDataList')

        }).catch(() => {}).finally(() => { this.actionBusy = false })

      }).catch(() => {})

    },

    remove() {

      this.$confirm('确定删除该单据?', '提示', { type: 'warning' }).then(() => {

        this.actionBusy = true

        request.post('/inventory/ratioIn/delete', { id: this.form.ratioInId }).then(() => {

          this.$message.success('操作成功')

          this.visible = false

          this.$emit('refreshDataList')

        }).catch(() => {}).finally(() => { this.actionBusy = false })

      }).catch(() => {})

    }

  }

}

</script>



<style scoped>

.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }

.doc-dialog-title { font-size: 16px; font-weight: 600; }

.doc-dialog-actions .el-button { margin-left: 0; }

.line-tools { margin-bottom: 10px; }

</style>


